import { render, staticRenderFns } from "./Mailings.vue?vue&type=template&id=73b184fc&scoped=true&"
import script from "./Mailings.vue?vue&type=script&lang=ts&"
export * from "./Mailings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b184fc",
  null
  
)

export default component.exports